import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomIn = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21 13C21 15.4553 19.7359 17.6154 17.823 18.8648L18.9285 21.6286C19.1336 22.1414 18.8842 22.7234 18.3714 22.9285C17.8586 23.1336 17.2766 22.8842 17.0715 22.3714L16.0063 19.7083C15.3707 19.8981 14.6973 20 14 20C10.134 20 7 16.866 7 13C7 9.13401 10.134 6 14 6C17.866 6 21 9.13401 21 13ZM14 18C16.7614 18 19 15.7614 19 13C19 10.2386 16.7614 8 14 8C11.2386 8 9 10.2386 9 13C9 15.7614 11.2386 18 14 18Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11,
			y: 12,
			width: 6,
			height: 2,
			rx: .5,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 13,
			y: 10,
			width: 2,
			height: 6,
			rx: .5,
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgZoomIn);
export { ForwardRef as ReactComponent };
